// Internazionalizzazione degli URL.
// IT alla radice (canonico/default), EN sotto /en/ con slug tradotti.
// La lingua e' derivata dal pathname. Questa mappa DEVE restare allineata con
// SITEMAP_STATIC_ROUTES + i prefissi dinamici lato backend (server.py).

// Path statici canonici (IT) -> EN
export const STATIC_PATHS = {
  "/": "/en",
  "/agenzia": "/en/about",
  "/team": "/en/team",
  "/servizi": "/en/services",
  "/servizi/local-seo-pro": "/en/services/local-seo-pro",
  "/analisi-google": "/en/google-analysis",
  "/analisi-google/grazie": "/en/google-analysis/thanks",
  "/portfolio": "/en/portfolio",
  "/contatti": "/en/contact",
  "/shop": "/en/shop",
  "/cart": "/en/cart",
  "/checkout": "/en/checkout",
  "/checkout/success": "/en/checkout/success",
  "/account": "/en/account",
  "/account/login": "/en/account/login",
  "/account/imposta-password": "/en/account/set-password",
  "/admin": "/en/admin",
};

// EN -> IT (reverse)
export const STATIC_PATHS_REV = Object.fromEntries(
  Object.entries(STATIC_PATHS).map(([it, en]) => [en, it]),
);

// Prefissi delle rotte dinamiche (detail pages)
export const DYNAMIC_PREFIXES = [
  { it: "/portfolio/", en: "/en/portfolio/" },
  { it: "/product/", en: "/en/product/" },
  { it: "/pagine/", en: "/en/pages/" },
];

export function detectLang(pathname) {
  return /^\/en(\/|$)/.test(pathname || "/") ? "en" : "it";
}

// nginx serve le pagine come directory e aggiunge lo slash finale (301):
// il pathname lato client puo' essere "/agenzia/" e NON combaciare con le chiavi
// della mappa ("/agenzia"). Normalizziamo togliendo lo slash finale (tranne "/").
function stripSlash(p) {
  return p.length > 1 ? p.replace(/\/+$/, "") : p;
}

function localizePath(path, enSlug) {
  if (path in STATIC_PATHS) return STATIC_PATHS[path];
  for (const { it, en } of DYNAMIC_PREFIXES) {
    if (path.startsWith(it)) {
      return en + (enSlug || path.slice(it.length));
    }
  }
  // fallback difensivo: prefissa /en
  return "/en" + (path === "/" ? "" : path);
}

// Localizza un path IT-canonico nella lingua target, preservando query/hash
// (es. "/shop?cat=x" o "/servizi#seo").
// enSlug: slug_en per le rotte dinamiche (se assente riusa lo slug del path).
export function localize(itPath, lang, enSlug) {
  if (lang !== "en") return itPath;
  const [, path, suffix = ""] = itPath.match(/^([^?#]*)([?#].*)?$/);
  return localizePath(stripSlash(path), enSlug) + suffix;
}

// Converte un path EN nel corrispondente IT-canonico (per lo switcher / default).
// Per le rotte dinamiche lo slug resta invariato (le detail page forniscono gli
// URL alternati precisi via registerAltUrls), qui e' un best-effort.
export function toItPath(pathname) {
  pathname = stripSlash(pathname);
  if (detectLang(pathname) === "it") return pathname;
  if (pathname in STATIC_PATHS_REV) return STATIC_PATHS_REV[pathname];
  for (const { it, en } of DYNAMIC_PREFIXES) {
    if (pathname.startsWith(en)) return it + pathname.slice(en.length);
  }
  return pathname.replace(/^\/en/, "") || "/";
}
